/**
 * Human-facing calendar dates only (e.g. "28 Apr 2026").
 * Does not affect API payloads or storage.
 */
const DISPLAY_DATE_LOCALE = "en-GB";

const DISPLAY_DATE_OPTIONS = Object.freeze({
  day: "numeric",
  month: "short",
  year: "numeric",
});

export const formatDisplayDate = (value) => {
  if (value == null || value === "") return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(DISPLAY_DATE_LOCALE, DISPLAY_DATE_OPTIONS);
};

/** Date + time for tables and admin lists (e.g. "28 Apr 2026, 14:30"). */
export const formatDisplayDateTime = (value) => {
  if (value == null || value === "") return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString(DISPLAY_DATE_LOCALE, {
    ...DISPLAY_DATE_OPTIONS,
    hour: "2-digit",
    minute: "2-digit",
  });
};
